// extracted by mini-css-extract-plugin
export default {"parent-mode":"help-page_parent-mode__SAbZY","categoryName":"help-page_categoryName__-7DrH"};